import {
  BrowserMessageReceiveType,
  BrowserMessageType,
  registerElectronMessageReceiver,
  sendElectronMessage,
} from 'electron-communication-lib/BrowserForApp';
import {useMountEffect} from 'webapp-lib/utils';

import {hasAnyActiveLock} from '_/hooks';

// Answers the Electron main process's UNSAVED_CHANGES_QUERY (sent before
// switching instance via an "open-instance" deep link) with whether any
// currently open form dialog has unsaved changes - see lock.tsx's
// globalLockState, the same registry every Management-screen form dialog
// registers into via useLock().
export function useHandleUnsavedChangesQuery(): void {
  useMountEffect(() => {
    registerElectronMessageReceiver(
      BrowserMessageReceiveType.UNSAVED_CHANGES_QUERY,
      handleUnsavedChangesQuery
    );
  });
}

function handleUnsavedChangesQuery() {
  sendElectronMessage({
    type: BrowserMessageType.UNSAVED_CHANGES_RESPONSE,
    payload: {hasUnsavedChanges: hasAnyActiveLock()},
  });
}
